import React from 'react';
import { motion } from 'framer-motion'; 
import Icon from '../../../components/AppIcon';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.60,
    },
  },
};

const getInitialVariant = (index) => {
  if (index % 2 === 0) {
    return { opacity: 0, x: -100 };
  } 
  else {
    return { opacity: 0, x: 100 };
  }
};

const ProcessTimeline = ({ steps }) => {
  return (
    <motion.div
      className="relative"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-primary-200 hidden lg:block"></div>
      
      <div className="space-y-6">
        {steps.map((step, index) => (
          <motion.div
            key={step.step}
         
            className="relative flex items-start space-x-8 group" 
            
            initial={getInitialVariant(index)}
            
            whileInView={{ opacity: 1, x: 0 }} 
            
            transition={{ type: 'spring', stiffness: 100, damping: 15 }} 
            
            viewport={{ 
              once: true, 
              amount: 0.3 
            }}
          >
            <motion.div
              className="flex-shrink-0 w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white font-bold text-xl relative z-20"
              whileHover={{ scale: 1.1, rotate: 3 }} 
              transition={{ type: "spring", stiffness: 400, damping: 15 }}
            >
              {step.step}
            </motion.div>
            
            {/* Content Card */}
            <motion.div
              className="flex-1 pb-4 pt-2"
              whileHover={{ y: -4 }}
              transition={{ duration: 0.2 }}
            >
              <div className="bg-surface rounded-lg p-8 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                <h3 className="text-2xl font-heading font-semibold text-text-primary mb-4">
                  {step.title}
                </h3>
                <p className="text-text-secondary leading-relaxed mb-4">
                  {step.description}
                </p>
                
                {/* Deliverables Section */}
                <div>
                  <h4 className="text-sm font-semibold text-text-primary mb-3 flex items-center">
                    <Icon name="Package" size={16} className="mr-2" />
                    Key Deliverables
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    {step.deliverables.map((deliverable, deliverableIndex) => (
                      <motion.div
                        key={deliverableIndex}
                        className="flex items-center space-x-2 p-3 bg-primary-50 rounded-lg"
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ 
                            delay: 0.1 * deliverableIndex,
                            duration: 0.3 
                        }}
                      >
                        <Icon name="CheckCircle" size={16} color="var(--color-primary)" />
                        <span className="text-sm text-primary font-medium">
                          {deliverable}
                        </span>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ProcessTimeline;